// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2sXQi","head":"Table_head__2lK0F","col":"Table_col__1decn"};